<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/program' }">
        <app-i18n code="entities.program.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.program.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.program.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-program-view-toolbar v-if="record"></app-program-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <!-- id -->
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>
        <!-- name -->
        <app-view-item-text :label="fields.name.label" :value="presenter(record, 'name')"></app-view-item-text>
        <!-- type -->
        <app-view-item-text :label="fields.type.label" :value="presenter(record, 'type')"></app-view-item-text>
        <!-- managers-->
        <app-view-item-relation-to-many
          :label="fields.managers.label"
          :permission="fields.managers.readPermission"
          :url="fields.managers.viewUrl"
          :value="presenter(record, 'managers')"
        ></app-view-item-relation-to-many>
        <!-- emails-->
        <app-view-item-text :label="fields.emails.label" :value="presenter(record, 'emails')"></app-view-item-text>
        <!-- status -->
        <app-view-item-custom :label="fields.status.label" :value="presenter(record, 'status')">
          <el-tag :type="propertyStatusTagType(record['status'])">{{ presenter(record, 'status') }}</el-tag>
        </app-view-item-custom>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProgramViewToolbar from '@modules/program/components/program-view-toolbar.vue';
import { ProgramModel } from '@modules/program/program-model';
import ProgramDays from '@modules/program/program-days';
import { propertyStatusTagType } from '@modules/property/property-enum-status';
import { propertyAccessTagType } from '@modules/property/property-enum-access';

const { fields } = ProgramModel;

export default {
  name: 'app-program-view-page',

  props: ['id'],

  components: {
    [ProgramViewToolbar.name]: ProgramViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'program/view/record',
      loading: 'program/view/loading',
    }),

    fields() {
      return fields;
    },
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'program/view/doFind',
    }),

    presenter(record, fieldName) {
      return ProgramModel.presenter(record, fieldName);
    },

    programDaysDescriptionOf(programId) {
      return ProgramDays.descriptionOf(programId);
    },

    programDaysLabelOf(programId) {
      return ProgramDays.labelOf(programId);
    },

    propertyStatusTagType(status) {
      return propertyStatusTagType(status);
    },

    propertyAccessTagType(status) {
      return propertyAccessTagType(status);
    },
  },
};
</script>
